import GlobalSearch from './connected/global-search-connected'
import Route from './search-routes'

export { Route, GlobalSearch }
export default {
  Route,
  GlobalSearch,
}
